import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { CoreLogService } from "../../services/log.service";

import { CoreLanguageService } from "../../services/language.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { UserHelperService } from "../../services/userHelper.service";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import Utils from "../../shared/utils";
import { WebShopService } from "../../services/webShop.service";
import { orderTypes } from "../../shared/contentTypes";

@Component({
  selector: "inHauseOrderConfirm",
  templateUrl: "./inHauseOrderConfirm.component.html",
  styleUrls: ["./inHauseOrderConfirm.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InHauseOrderConfirmComponent implements OnInit, OnDestroy {

  private _langSubscriber: Subscription;

  private _orderConfirm_Subtext: string = "";

  constructor(public _userHelperService: UserHelperService
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _inHouseOrderService: InHouseOrderService
    , private _webShopService: WebShopService) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("InHauseOrderConfirmComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    if (me._userHelperService.IsRegistered) {
      // todo was ist das hier?
      me._coreLogService.error("InHauseOrderConfirmComponent.PushChanges", "!user.IsRegistered Result page--> INIT Method");
    }

    me._webShopService.getWebshopSettingsDataModel().then((settings) => {
      const location = me._inHouseOrderService.TableData.location;
      if (location) {
        const ih_ordertype = settings.ordertypes.find((ordertype) => ordertype.id == orderTypes.inHouse);
        if (ih_ordertype) {
          const location_settings = ih_ordertype.location_settings.find((loc_settings) => loc_settings.location === location)
          if (location_settings) {
            me._orderConfirm_Subtext = location_settings.order_confirmation_extra_text;
            me.PushChanges();
          } // else es ist keine abweichende standort einstellung
        } else {
          me._coreLogService.error("InHauseOrderConfirmComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel no ih_ordertype");
        }
      } else {
        me._coreLogService.error("InHauseOrderConfirmComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel no location");
      }
    }).catch((error) => {
      me._coreLogService.error("InHauseOrderConfirmComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel catch", error);
    });

    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }

  /** group name */
  public get groupName(): string {
    return this._inHouseOrderService.GroupName;
  }

  /** is group order */
  public get isGroupOrder(): boolean {
    return !Utils.IsNullOrEmpty(this.groupName);
  }

  public get groupOrderConfirm_HTML(): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_Confirm_HTML")
      .replace("{group_name}", `<span class="emphasized">${me.groupName}</span>`);
  }

  public get orderConfirm_Subtext(): string {
    const me = this;
    return me._orderConfirm_Subtext;
  }

  /** Bestell bestätigungstext mit der Tischnummer */
  public get orderResult_HTML(): string {
    const me = this;
    return me._coreLanguageService.value("phInHouse_Order_Confirm_HTML").replace("{table_no}", `<span class="emphasized">${me._inHouseOrderService.UiData.table_no}</span>`);
  }

  /** Navigate to service selection */
  public openInHouseLandingPage() {
    const me = this;
    me._inHouseOrderService.openInHauseLandingPage();
  }

}
